import Vue from "vue";

import AdditionalRewards from "./AdditionalRewards.vue";

export function load() {
    const selector = "additional-rewards";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(AdditionalRewards, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
